<template>

<app-content :loading="is.loading && !is.initialised">

	<app-content-head title="Play to Win" subtitle="Manage the games that can be won by checking them out." :readonly="$authorised('con/checkout/access', 'read')">

		<app-content-head-actions-panel v-if="collection.length" text="Export" icon="export" component="manager/common/panel/Export" :data="importexportData" />

		<app-content-head-actions-item tooltip="Add new game to Play to Win" text="Add" icon="create" v-on:click="onCreateClick" />
		
		<app-content-head-actions-item tooltip="Randomly award selected games to eligible participants" text="Award" icon="play" :loading="is.gifting" :disabled="!selected.length" v-on:click="onGiftClick" />

	</app-content-head>

	<app-content-filters :changed="isFilterDirty" v-on:reset="onResetFilter">

		<app-content-filters-search v-model="filter.search" />

		<app-content-filters-tags v-model="filter.status" :options="filterStatus" />
		
		<app-content-filters-select v-model="filter.sort" text="Sort by" prefix="Sort by" tooltip="Change sorting" :options="$util.options(filterSorts)" />

	</app-content-filters>

	<app-content-body :loading="is.loading && is.initialised" :is-empty="!collection.length" placeholder="Sorry, no games found.">

		<app-table>

			<app-table-head :layout="layout">

				<app-table-column />

				<app-table-column :sorted="filter.sort === 'game'" text="Game" />

				<app-table-column :sorted="filter.sort === 'badge'" text="Won by" />

				<app-table-column :sorted="filter.sort === 'date'" text="Awarded on" />

				<app-table-column :sorted="filter.sort === 'participants'" border="left" align="center" text="Participants" />

				<app-table-column :sorted="filter.sort === 'loans'" border="right" align="center" text="Loans" />

				<app-table-column />

			</app-table-head>

			<app-table-body>

				<app-table-row v-on:click="onEditClick(item.id)" :layout="layout" v-for="item in collection" :key="item.id">

					<app-table-cell-label :text="$constants.checkout.win.statusName[item.status]" :type="$constants.checkout.win.statusTheme[item.status]" :subtext="item.reference" />

					<app-table-cell-item type="organisation/library/game" :item="item.game" />

					<app-table-cell-item type="convention/badge" :item="item.badge" />
					
					<app-table-cell-text :text="item.date | localDate('h:mma')" :subtext="item.date | localDate('dddd')" v-if="item.date" />
					<app-table-cell-text :can-empty="true" v-if="!item.date" />

					<app-table-cell-text border="left" align="center" :text="item.count.participants" />

					<app-table-cell-text border="right" align="center" :text="item.count.plays" />

					<app-table-cell-select v-if="item.count.participants && item.status === $constants.checkout.win.status.pending" :active="isSelected(item.id)" v-on:click="onSelectToggle(item.id)" />

				</app-table-row>

			</app-table-body>

			<app-table-foot :pagination="pagination" :total="total" />

		</app-table>

	</app-content-body>

</app-content>

</template>

<script>

import mixCollection from '@/mixin/collection'

export default {

	mixins: [mixCollection],

	data: function() {

		return {
			is: {
				gifting: false
			},
			layout: '120px minmax(0, 1fr) minmax(0, 1fr) 120px 100px 100px 40px',
			endpoint: 'convention/checkout/wins',
			live: 'convention/checkout/wins',
			edit: 'Convention.Checkout.Wins.Edit',
			filter: {
				sort: 'game',
				status: []
			},
			filterStatus: [
				{ value: 1, text: 'Pending', theme: 'red' },
				{ value: 2, text: 'Won', theme: 'green' },
			],
			filterSorts: {
				'game': 'Game',
				'badge': 'Winner',
				'date': 'Date Awarded',
				'participants': 'Participants',
				'loans': 'Loans'
			}
		}

	},

	computed: {
	
		importexportData: function() {

			return {
				columns: {
					'reference': 'Reference',
					'status': 'Status',
					'gameReference': 'Game Reference',
					'gameName': 'Game Name',
					'gameVersion': 'Game Version',
					'badgeReference': 'Winner Reference',
					'badgeName': 'Winner Name',
					'participants': 'Participants',
					'loans': 'Loans',
					'date': 'Awarded Date'
				},
				requiredColumns: [],
				valueMapping: {},
				params: this.getParams(),
				index: this.selectedIndex,
				endpoint: this.endpoint
			}

		}

	},

	methods: {

		onGiftClick: function() {

			this.is.gifting = true

			this.$api.patch(this.endpoint, {
				index: this.selected
			}).then(function() {

				this.selected = []
				this.is.gifting = false

			}.bind(this))

		}

	}

}

</script>

<style scoped>

</style>